module.exports = __webpack_public_path__ + "img/book_2_zh.d0237791.png";